module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back":"Zurück","dashboard":"Dashboard","exams":"Prüfungen","subjects":"Module","trainees":"Trainees","categories":"Kategorien","departments":"Abteilungen","tenants":"Mandanten"},"en":{"back":"Back","dashboard":"Dashboard","exams":"Exams","subjects":"Subjects","trainees":"Trainees","categories":"Categories","departments":"Departments","tenants":"Tenants"}}')
  delete Component.options._Ctor
}
